import React from 'react';
import { motion } from 'framer-motion';
export function PainAmplification() {
  return <section className="py-20 md:py-28 bg-cream text-ink relative" data-id="element-477">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl text-center" data-id="element-478">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-6" data-id="element-479">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-8" data-id="element-480">
            Piénsalo un momento.
          </h2>

          <p className="text-lg md:text-xl font-light leading-relaxed" data-id="element-481">
            Gastaste semanas buscando el salón perfecto. Meses eligiendo el
            vestido. Horas probando el menú, las flores, la decoración.
          </p>

          <p className="text-lg md:text-xl font-light leading-relaxed" data-id="element-482">
            Coordinaste a familiares que vienen de tres estados diferentes. Le
            explicaste al DJ tres veces la lista de canciones. Lloraste de
            estrés más de una noche.
          </p>

          <p className="text-xl md:text-2xl font-medium text-gold-dark py-4" data-id="element-483">
            Todo para que ese día sea perfecto.
          </p>

          <p className="text-lg md:text-xl font-light leading-relaxed" data-id="element-484">
            Y el día llegó. Fue hermoso. Fue mágico. Fue todo lo que soñaste.
          </p>

          <div className="flex items-center justify-center py-8" data-id="element-485">
            <div className="h-px bg-gold/30 w-16" data-id="element-486"></div>
            <div className="w-2 h-2 rounded-full bg-gold mx-4" data-id="element-487"></div>
            <div className="h-px bg-gold/30 w-16" data-id="element-488"></div>
          </div>

          <p className="text-2xl md:text-3xl font-serif text-charcoal" data-id="element-489">
            Y entonces… terminó.
          </p>

          <p className="text-lg md:text-xl font-light leading-relaxed pt-4" data-id="element-490">
            Los invitados se fueron. La familia regresó a sus ciudades. La
            abuela tomó su vuelo de regreso.
          </p>

          <p className="text-xl md:text-2xl font-medium text-charcoal" data-id="element-491">
            Y en sus manos no llevaba nada.
          </p>

          <p className="text-lg md:text-xl font-light leading-relaxed" data-id="element-492">
            Solo el recuerdo en su corazón — que con el tiempo, se va borrando.
          </p>

          <div className="pt-8 p-8 bg-white rounded-2xl shadow-sm border border-gold/10 mt-8" data-id="element-493">
            <p className="text-xl md:text-2xl font-serif font-semibold text-gold-dark" data-id="element-494">
              ¿No merecía ese día algo más? ¿No merecía tu familia llevarse algo
              real?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}